
enum StatisticsStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description get remax`s statistics
   */
  statistics = "/v2/statistics",
}

const StatisticsDynamic = {
  // /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get Statistics details
  //  */
  // StatisticsDetail: (StatisticsID?: number) =>
  //   `-${StatisticsID}`,
};

export const StatisticsEndpoints = {
  ...StatisticsDynamic,
  ...StatisticsStatic,
};

export type StatisticsEndpoints = typeof StatisticsEndpoints;
